import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Apollo} from 'apollo-angular';
import { IImportJob, ListImportJobsQuery } from '@ebb-v2/ebb-integration';
import { ImportJobApiService } from '../index';

@Injectable({
    providedIn: 'root'
  })
  export class ImportJobGqlService implements ImportJobApiService {

    constructor(
      private apollo: Apollo
    ) { }

    public getImportJobList(): Observable<IImportJob[]> {
      return this.apollo
        .query ({
          query: ListImportJobsQuery,
          fetchPolicy: 'network-only'
        })
        .pipe(map(result => result.data['importjobs'] as IImportJob[]));
    }

  }
